import React, { useCallback, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAutoB } from "../../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";

function PatientRightPopup(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { selectedRow, setUpdateFlag } = props;
  const [data, setData] = useState(null);

  const refForm1 = useRef(null);
  const dispatch = useDispatch();
  //----------------------------------------------------------------------

  useEffect(() => {
    if (selectedRow) {
      getData(() => {
        selectedRow.action("ready");
      });
    }
  }, [selectedRow]);

  //----------------------------------------------------------------------
  const getData = (goReady) => {
    if (selectedRow && selectedRow.row && selectedRow.row.patrightid === 0) {
      setData(null);
      goReady();
      return;
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/patient-rights/get-data",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          setData(res.data.rows[0]);
          goReady();
        }
      })
      .catch((err) =>
        dispatch(setReminder({ show: true, message: err.message }))
      );
  };

  //----------------------------------------------------------------------
  //Saving Data TO server
  const saveData = (evt) => {
    const dForm1 = new FormData(refForm1.current);
    const fData1 = Object.fromEntries(dForm1);

    let dataToSave = {
      ItemId: selectedRow.row["patrightid"],
      SaveInfo: fData1,
      UserDetail: userDetail,
    };

    if (selectedRow.patrightid === 0) {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        createby: userDetail.userid,
      };
    } else {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        updateby: userDetail.userid,
      };
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/patient-rights/update",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(setReminder({ show: true, message: "บันทึกสมบูรณ์" }));
        setWinState({ show: false });
        setUpdateFlag(true);
      })
      .catch((err) =>
        dispatch(setReminder({ show: true, message: err.message }))
      );
  };

  //----------------------------------------------------------------------
  // FIELDS Ojbect list
  const FILEDS = [
    { label: "รหัส", oName: "patrightcode", require: true, type: "text" },
    { label: "ชื่อสิทธิ", oName: "patrightname", require: true, type: "text" },
    { label: "ชื่อสั้น", oName: "patrightshort", require: true, type: "text" },
  ];
  //----------------------------------------------------------------------
  // Return Zone
  return (
    <MyModal show={winState.show} size="lg" centered backdrop={false}>
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${props.formName ? props.formName : "รายการ"}`}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        {FILEDS ? (
          <FormAutoB
            {...{ formId: "form1", items: FILEDS, data: data, refTo: refForm1 }}
          />
        ) : null}
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" onClick={() => saveData()}>
          Save changes
        </Button>
        <Button variant="danger" onClick={() => setWinState({ show: false })}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}

export default PatientRightPopup;
